'use client';
import React, { createContext, useContext, useReducer } from 'react';

interface TransactionDetails {
    hash: string;
    approval?: { tokenAddress: string; spender: string };
    summary?: string;
    claim?: { recipient: string };
    receipt?: {
        to: string;
        from: string;
        contractAddress: string;
        transactionIndex: number;
        blockHash: string;
        transactionHash: string;
        blockNumber: number;
        status?: number;
    };
    lastCheckedBlockNumber?: number;
    addedTime: number;
    confirmedTime?: number;
    from: string;
}

interface TransactionState {
    [chainId: number]: {
        [txHash: string]: TransactionDetails;
    };
}

const initialState: TransactionState = {};

const TransactionContext = createContext<{
    state: TransactionState;
    dispatch: React.Dispatch<any>;
}>({
    state: initialState,
    dispatch: () => null,
});

const transactionReducer = (state: TransactionState, action: any): TransactionState => {
    // Implement reducer logic similar to your Redux reducer
    return state;
};

export const TransactionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(transactionReducer, initialState);

    return (
        <TransactionContext.Provider value={{ state, dispatch }}>
            {children}
        </TransactionContext.Provider>
    );
};

export const useTransactionContext = () => useContext(TransactionContext);